import React from 'react';
import AdminSearchTable from '../Admin/AdminSearchTable'

const WithdrawHistorySection = ({ model }) => {
    const claims = model?.claimsHistory || [];

    const columns = [
        { label: 'Transaction Date', accessor: 'entryDate' },
        { label: 'Amount', accessor: 'amountDisplay' },
        { label: 'State Withheld', accessor: 'stateWH' },
        { label: 'Federal Withheld', accessor: 'fitWH' },
        { label: 'Description', accessor: 'category' },
        { label: 'Surrender Charge', accessor: 'surrenderCharge' },
        { label: 'Net Check Amount', accessor: 'netCheckAmount' },
    ];

    if (claims.length === 0) {
        return (
            <div className="container container-section" id="claims-history-container">
                <div className="card notfoundbox rounded-3 shadow-lg">
                    <div className="card-body">
                        <div className="flex-container">
                            <h5>No Withdrawals Found</h5>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="container container-section" id="claims-history-container">
            <AdminSearchTable columns={columns} data={claims} /> 
        </div>
    );
};

export default WithdrawHistorySection;
